import { render, staticRenderFns } from "./PromoDialog.vue?vue&type=template&id=7ca4e646&"
import script from "./PromoDialog.vue?vue&type=script&lang=js&"
export * from "./PromoDialog.vue?vue&type=script&lang=js&"
import style0 from "./PromoDialog.vue?vue&type=style&index=0&id=7ca4e646&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports